import {
  Dashboard,
  HomeOutlined,
  Person,
  ShoppingCartOutlined,
} from "@mui/icons-material";
import { Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Icon from "./HOC/Icon";
import useAccount from "../hooks/useAccount";
import { useSelector } from "react-redux";

// const returnPage = (link) => link === 0 ? ''
// :
// link ===  1 ? 'order'
// :
// link ===  2 ? 'users'
// :
// link ===  3 ? 'support'
// :
// 0

export default function NavLinks({ profileCompleted }) {
  const {
    userData: { user },
  } = useSelector((state) => state.user);
  const location = useLocation();
  const locations = location.pathname?.split("/");
  const page = locations[1] || "";
  const navigate = useNavigate();
  const [link, setLink] = useState(0);
  // const profileComplete = user?.detail?.isProfileComplete;
  const { checkPermission } = useAccount();

  // const [initialPage,setInitialPage] = useState(link);

  const tabs = {
    home: {
      field: "",
      label: "Home",
      link: "/",
      action: () => handleNav("/"),
      Icon: <HomeOutlined />,
    },
    dashboard: {
      field: "dashboard",
      label: "Dashboard",
      link: "/dashboard",
      action: () => handleNav("/dashboard"),
      Icon: <Dashboard />,
    },
    order: {
      field: "order",
      label: "Orders",
      link: "/order",
      action: () => handleNav("/order"),
      Icon: <ShoppingCartOutlined />,
    },
    reportDashboard: {
      field: "reportDashboard",
      label: "reportDashboard",
      link: "/reportDashboard",
      action: () => handleNav("/reportDashboard"),
      Icon: <Dashboard />,
    },
    transactions: {
      field: "transactions",
      label: "Transactions",
      link: "/transactions",
      action: () => handleNav("/transactions"),
      Icon: <Icon icon="tdesign:undertake-transaction" />,
    },
    tasks: {
      field: "tasks",
      label: "Tasks",
      link: "/tasks",
      action: () => handleNav("/tasks"),
      Icon: <Icon icon="clarity:tasks-line" />,
    },
    points: {
      field: "points",
      label: "Elite Points",
      link: "/tasks",
      action: () => handleNav("/points"),
      Icon: <Icon icon="fa6-solid:medal" />,
    },
    users: {
      field: "users",
      label: "Agents",
      link: "/users",
      action: () => handleNav("/users"),
      Icon: <Person />,
    },
  };

  const pages = [];

  pages.push(tabs["home"]);
  if (user?.userType !== "Staff") pages.push(tabs.dashboard);
  pages.push(tabs.order);
  if (checkPermission("read:transactions")) pages.push(tabs.transactions);
  pages.push(tabs.reportDashboard);
  pages.push(tabs.tasks);
  pages.push(tabs.points);
  if (checkPermission("read:all-users")) pages?.push(tabs.users);

  useEffect(() => {
    // let pag = (page === '' ? 0
    // :
    // page === 'order' ? 1
    // :
    // page === 'transactions' ? 2
    // :
    // page === 'tasks' ? 3
    // :
    // page === 'users' ? 4
    // :
    // page === 'support' ? 5
    // :
    // 0)
    setLink(pages?.findIndex((val) => val?.field === page) || 0);
    //eslint-disable-next-line
  }, [page]);

  // useEffect(() => {
  //   // let link = ev.target.getAttribute('link');
  //   if(initialPage !== link) {

  //     navigate(returnPage(link));
  //     setInitialPage(link)
  //   }
  // },[link,navigate,initialPage])

  function handleLink(ev, val) {
    setLink(val);
    console.log(window.location.pathname);
    // navigate(ev.target.dataset.link)
  }

  function handleNav(link) {
    if (link === window.location.pathname) window.location.reload();

    navigate(link);
  }

  return profileCompleted ? (
    <div className="">
      <Tabs
        variant="scrollable"
        value={link}
        onChange={handleLink}
        className="font-bold"
        TabIndicatorProps={{ sx: { height: "4px" } }}
      >
        {/* {!profileComplete?
          <Tab label='Getting Started' data-link="/welcome" icon={<Icon icon='heroicons:rocket-launch' className=' -rotate-[43deg]' />} iconPosition="start" className='!capitalize !min-w-[150px] md:flex-1 !whitespace-nowrap' />
        :null} */}
        {/* <Tab label='Home' onClick={() => handleNav("/")} data-link="/" icon={<HomeOutlined />} iconPosition="start" className='!capitalize md:flex-1 !whitespace-nowrap' />
        <Tab label='Orders' onClick={() => handleNav("/order")} data-link="/order" icon={<ShoppingCartOutlined />} iconPosition="start" className='!capitalize md:flex-1 !whitespace-nowrap' />
        <Tab label='Transactions' onClick={() => handleNav("/transactions")} data-link="/transactions" icon={<Icon icon='tdesign:undertake-transaction' />} iconPosition="start" className='!capitalize md:flex-1 !whitespace-nowrap' />
        <Tab label='Tasks' onClick={() => handleNav("/tasks")} data-link="/tasks" icon={<Icon icon='clarity:tasks-line' />} iconPosition="start" className='!capitalize md:flex-1 !whitespace-nowrap' />
        <Tab label='Customers' onClick={() => handleNav("/users")} data-link="/users" icon={<Person />} iconPosition="start" className='!capitalize md:flex-1 !whitespace-nowrap' /> */}
        {pages?.map((obj, i) => (
          <Tab
            key={i}
            label={obj?.label}
            onClick={() => obj?.action && obj?.action()}
            data-link={obj?.link}
            icon={obj?.Icon}
            iconPosition="start"
            className="!capitalize md:flex-1 !whitespace-nowrap"
          />
        ))}
        {/* <Tab label='Support' data-link="/support" icon={<SupportAgentOutlined />} iconPosition="start" className='!capitalize md:flex-1 !whitespace-nowrap' /> */}
      </Tabs>
    </div>
  ) : (
    <div>
      {/* <Tabs variant="scrollable" value={link} onChange={handleLink} className="font-bold" 
        TabIndicatorProps={{sx: {height: '4px'}}}>
          {page === 'welcome' ? 
            <Tab label='Support' data-link="/" icon={<Icon icon='heroicons:rocket-launch' className='text-theme1 -rotate-[43deg]' />} iconPosition="start" className='!capitalize md:flex-1 !whitespace-nowrap' />
          :
            <Tab label='Getting Started' data-link="/" icon={<Icon icon='heroicons:rocket-launch' className='text-theme1 -rotate-[43deg]' />} iconPosition="start" className='!capitalize md:flex-1 !whitespace-nowrap' />
          }
      </Tabs> */}
    </div>
  );
}
